// // src/components/SearchResultsPage.jsx

// import { useEffect, useState, useCallback } from "react";
// import { useSearchParams } from "react-router-dom";
// import { searchProducts } from "../api/searchApi";
// import BackButton from "./BackButton";

// export default function SearchResultsPage() {
//   const [searchParams] = useSearchParams();
//   const query = searchParams.get("q");

//   const [results, setResults] = useState([]);
//   const [nextPageToken, setNextPageToken] = useState("");
//   const [totalSize, setTotalSize] = useState(0);
//   const [correctedQuery, setCorrectedQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // You Might Also Like
//   const [youMightLike, setYouMightLike] = useState([]);

//   // Load results with pagination support
//   const loadResults = useCallback(
//     async (token = "") => {
//       if (!query) return;

//       if (!token) setLoading(true);
//       setError("");

//       try {
//         const data = await searchProducts(query, 10, token);

//         const newRecords = data.records.map((p) => ({
//           id: p.article_id,
//           name: p.prod_name,
//           price: parseFloat(p.price).toFixed(2),
//           image: p.image_uri
//             ?.replace("storage.cloud.google.com", "storage.googleapis.com")
//             ?.trim(),
//           currency: p.currency,
//           description: p.detail_desc || "No description available.",
//         }));

//         setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
//         setNextPageToken(data.next_page_token || "");
//         setTotalSize(data.totalSize || 0);
//         setCorrectedQuery(data.correctedQuery || "");

//         if (!token && newRecords.length > 0) {
//           const shuffled = [...newRecords].sort(() => 0.5 - Math.random());
//           setYouMightLike(shuffled.slice(0, 5));
//         }
//       } catch (err) {
//         setError(err.message || "Search failed. Please try again.");
//         setResults([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [query]
//   );

//   // Load initial results
//   useEffect(() => {
//     if (query) {
//       loadResults("");
//     } else {
//       setLoading(false);
//     }
//   }, [query, loadResults]);

//   const loadMore = () => {
//     if (nextPageToken) {
//       loadResults(nextPageToken);
//     }
//   };

//   if (!query) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">No search query provided.</p>
//       </div>
//     );
//   }

//   if (loading && results.length === 0) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Searching...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10">
//       <BackButton />

//       <h1 className="text-3xl font-bold text-gray-900 mb-6">
//         Search Results for "{query}"
//       </h1>

//       {/* ✅ Show result count and "Did you mean?" */}
//       {!error && (
//         <>
//           <h2 className="text-xl text-gray-800 mb-4">
//             Showing {results.length} of {totalSize} results for "{query}"
//           </h2>

//           {/* Did you mean? */}
//           {correctedQuery && correctedQuery.trim() !== query.trim() && (
//             <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
//               <p className="text-sm text-blue-800">
//                 <span className="font-medium">Did you mean:</span>{" "}
//                 <button
//                   type="button"
//                   onClick={() =>
//                     (window.location.href = `?q=${encodeURIComponent(correctedQuery)}`)
//                   }
//                   className="text-blue-600 underline hover:text-blue-800 font-medium"
//                 >
//                   {correctedQuery}
//                 </button>
//                 ?
//               </p>
//             </div>
//           )}
//         </>
//       )}

//       {error && <p className="text-red-600 mb-6">{error}</p>}

//       {/* Results Grid */}
//       {results.length === 0 ? (
//         <p className="text-gray-600">No products found.</p>
//       ) : (
//         <>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//             {results.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={item.image || `https://picsum.photos/seed/${item.id}/400/600`}
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{item.name}</h3>
//                   <p className="text-blue-600 font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-3">{item.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {nextPageToken && (
//             <div className="text-center mt-8">
//               <button
//                 onClick={loadMore}
//                 className="px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800 font-medium"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </>
//       )}

//       {/* You Might Also Like */}
//       {youMightLike.length > 0 && (
//         <div className="mt-12">
//           <h2 className="text-2xl font-bold text-gray-900 mb-6">You Might Also Like</h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6">
//             {youMightLike.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/like-${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/like-${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{item.name}</h3>
//                   <p className="text-blue-600 font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-2">{item.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

//cahnges
//correct 
// src/components/SearchResultsPage.jsx
// import { useEffect, useState, useCallback } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom"; // ✅ Added useNavigate
// import { searchProducts, getProductDetails } from "../api/searchApi"; // ✅ Import new API function
// import BackButton from "./BackButton";

// export default function SearchResultsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate(); // ✅ Initialize navigate
//   const query = searchParams.get("q");

//   const [results, setResults] = useState([]);
//   const [nextPageToken, setNextPageToken] = useState("");
//   const [totalSize, setTotalSize] = useState(0);
//   const [correctedQuery, setCorrectedQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [attributionToken, setAttributionToken] = useState(""); // ✅ Store attribution token

//   // You Might Also Like
//   const [youMightLike, setYouMightLike] = useState([]);

//   // Load results with pagination support
//   const loadResults = useCallback(
//     async (token = "") => {
//       if (!query) return;

//       if (!token) setLoading(true);
//       setError("");

//       try {
//         const data = await searchProducts(query, 10, token);

//         const newRecords = data.records.map((p) => ({
//           id: p.article_id,
//           name: p.prod_name,
//           price: parseFloat(p.price).toFixed(2),
//           image: p.image_uri
//             ?.replace("storage.cloud.google.com", "storage.googleapis.com")
//             ?.trim(),
//           currency: p.currency,
//           description: p.detail_desc || "No description available.",
//         }));

//         setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
//         setNextPageToken(data.next_page_token || "");
//         setTotalSize(data.totalSize || 0);
//         setCorrectedQuery(data.correctedQuery || "");
//         setAttributionToken(data.attributionToken || ""); // ✅ Store the attribution token

//         if (!token && newRecords.length > 0) {
//           const shuffled = [...newRecords].sort(() => 0.5 - Math.random());
//           setYouMightLike(shuffled.slice(0, 5));
//         }
//       } catch (err) {
//         setError(err.message || "Search failed. Please try again.");
//         setResults([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [query]
//   );

//   // Load initial results
//   useEffect(() => {
//     if (query) {
//       loadResults("");
//     } else {
//       setLoading(false);
//     }
//   }, [query, loadResults]);

//   // ✅ Handle product click - navigate to product detail page
//   const handleProductClick = async (product) => {
//     try {
//       // Show loading state or spinner if needed
//       setLoading(true);

//       // Get detailed product information using the attribution token
//       const productDetails = await getProductDetails(
//         product.id,
//         attributionToken,
//         correctedQuery
//       );

//       // Navigate to product detail page with the product data
//       navigate(`/product/${product.id}`, {
//     state: {
//       product: productDetails,
//       attributionToken: attributionToken,
//       searchQuery: query, // Original query
//       correctedQuery: correctedQuery, // Corrected query from search API
//       fromSearch: true,
//       isInitialCall: true // Mark this as initial call
//     }
//   });
//     } catch (err) {
//       // If there's an error getting details, still navigate but show error in detail page
//       navigate(`/product/${product.id}`, {
//         state: {
//           product: product,
//           fromSearch: true,
//           attributionToken: attributionToken,
//           error: err.message,
//         },
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadMore = () => {
//     if (nextPageToken) {
//       loadResults(nextPageToken);
//     }
//   };

//   if (!query) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">No search query provided.</p>
//       </div>
//     );
//   }

//   if (loading && results.length === 0) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Searching...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10">
//       <BackButton />

//       {/* ✅ Show result count and "Did you mean?" */}
//       {!error && (
//         <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
//           {/* Left side - Results count */}
//           <h1 className="text-xl text-gray-800 mb-4">
//             Showing {results.length} of {totalSize} results for "{query}"
//           </h1>

//           {/* Right side - Did you mean? (only show if correction exists) */}
//           {correctedQuery && correctedQuery.trim() !== query.trim() && (
//             <div className="md:self-center">
//               <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-3 shadow-sm transition-all duration-200 hover:shadow-md min-w-[280px]">
//                 <div className="flex items-center space-x-2">
//                   <div className="flex-shrink-0">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-4 w-4 text-blue-500"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm font-medium text-blue-800">
//                       Did you mean:
//                       <button
//                         type="button"
//                         onClick={() =>
//                           (window.location.href = `?q=${encodeURIComponent(
//                             correctedQuery
//                           )}`)
//                         }
//                         className="ml-1 inline-flex items-center px-2 py-1 bg-white text-blue-700 text-xs font-semibold rounded-full border border-blue-300 shadow-sm hover:bg-blue-50 hover:border-blue-400 active:bg-blue-100 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transform hover:scale-105"
//                       >
//                         <span>{correctedQuery}</span>
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           className="h-3 w-3 ml-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M14 5l7 7m0 0l-7 7m7-7H3"
//                           />
//                         </svg>
//                       </button>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {error && <p className="text-red-600 mb-6">{error}</p>}

//       {/* Results Grid */}
//       {results.length === 0 ? (
//         <p className="text-gray-600">No products found.</p>
//       ) : (
//         <>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//             {results.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col cursor-pointer"
//                 onClick={() => handleProductClick(item)} // ✅ Add click handler
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                     {item.name}
//                   </h3>
//                   <p className="text-blue-600 font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-3">
//                     {item.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {nextPageToken && (
//             <div className="text-center mt-8">
//               <button
//                 onClick={loadMore}
//                 className="px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800 font-medium"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </>
//       )}

//       {/* You Might Also Like */}
//       {youMightLike.length > 0 && (
//         <div className="mt-12">
//           <h2 className="text-2xl font-bold text-gray-900 mb-6">
//             You Might Also Like
//           </h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6">
//             {youMightLike.map((item) => (
//               <div
//                 key={item.id}
//                 className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col cursor-pointer"
//                 onClick={() => handleProductClick(item)} // ✅ Add click handler
//               >
//                 <div className="flex-shrink-0">
//                   <img
//                     src={
//                       item.image ||
//                       `https://picsum.photos/seed/like-${item.id}/400/600`
//                     }
//                     alt={item.name}
//                     className="w-full h-64 object-cover"
//                     onError={(e) => {
//                       e.target.src = `https://picsum.photos/seed/like-${item.id}/400/600`;
//                     }}
//                   />
//                 </div>
//                 <div className="p-3 flex-1 flex flex-col">
//                   <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                     {item.name}
//                   </h3>
//                   <p className="text-blue-600 font-semibold mt-1">
//                     {item.currency} {item.price}
//                   </p>
//                   <p className="text-xs text-gray-600 mt-2 line-clamp-2">
//                     {item.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// src/components/SearchResultsPage.jsx
import { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { searchProducts, getProductDetails } from "../api/searchApi";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
  Rating,
  Alert,
  CircularProgress,

} from "@mui/material";
import {

  InfoOutlined,
  ArrowForward,
  FilterList,
  Sort,
} from "@mui/icons-material";
import WishlistToggle from "./WishlistToggle";
import { trackSearchPerformed } from "../services/uiAgentSync";

export default function SearchResultsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get("q");

  const [results, setResults] = useState([]);
  const [nextPageToken, setNextPageToken] = useState("");
  const [totalSize, setTotalSize] = useState(0);
  const [correctedQuery, setCorrectedQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attributionToken, setAttributionToken] = useState("");
  const [youMightLike, setYouMightLike] = useState([]);

  // Load results with pagination support
  const loadResults = useCallback(
    async (token = "") => {
      if (!query) return;

      if (!token) setLoading(true);
      setError("");

      try {
        const data = await searchProducts(query, 10, token);

        const newRecords = data.records.map((p) => ({
          id: p.article_id,
          name: p.prod_name,
          price: parseFloat(p.price).toFixed(2),
          image: p.image_uri
            ?.replace("storage.cloud.google.com", "storage.googleapis.com")
            ?.trim(),
          currency: p.currency,
          description: p.detail_desc || "No description available.",
          rating: Math.random() * 2 + 3, // Generate random rating between 3-5
          reviews: Math.floor(Math.random() * 100) + 1, // Generate random review count
        }));

        setResults((prev) => (token ? [...prev, ...newRecords] : newRecords));
        setNextPageToken(data.next_page_token || "");
        setTotalSize(data.totalSize || 0);
        setCorrectedQuery(data.correctedQuery || "");
        setAttributionToken(data.attributionToken || "");

        if (!token && newRecords.length > 0) {
          const shuffled = [...newRecords].sort(() => 0.5 - Math.random());
          setYouMightLike(shuffled.slice(0, 5));
        }

        // UI → Agent sync: report the manual search (IDs only, first page)
        if (!token) {
          trackSearchPerformed({
            query,
            resultProductIds: newRecords.map((r) => r.id),
            resultCount:
              typeof data.totalSize === "number" && data.totalSize > 0
                ? data.totalSize
                : newRecords.length,
          });
        }
      } catch (err) {
        setError(err.message || "Search failed. Please try again.");
        setResults([]);
      } finally {
        setLoading(false);
      }
    },
    [query]
  );

  // Load initial results
  useEffect(() => {
    if (query) {
      loadResults("");
    } else {
      setLoading(false);
    }
  }, [query, loadResults]);

  // Handle product click - navigate to product detail page
  const handleProductClick = async (product) => {
    try {
      setLoading(true);

      const productDetails = await getProductDetails(
        product.id,
        attributionToken,
        correctedQuery
      );

      navigate(`/product/${product.id}`, {
        state: {
          product: productDetails,
          attributionToken: attributionToken,
          searchQuery: query,
          correctedQuery: correctedQuery,
          fromSearch: true,
          isInitialCall: true,
        },
      });
    } catch (err) {
      navigate(`/product/${product.id}`, {
        state: {
          product: product,
          fromSearch: true,
          attributionToken: attributionToken,
          error: err.message,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => {
    if (nextPageToken) {
      loadResults(nextPageToken);
    }
  };

  // Product Card Component matching Figma design
  const ProductCard = ({ item, badge }) => (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        transition: "all 0.3s ease",
        position: "relative",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
        },
      }}
      onClick={() => handleProductClick(item)}
    >
      {/* Badge */}
      {badge && (
        <Chip
          label={badge}
          size="small"
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            zIndex: 1,
            bgcolor:
              badge === "Sale"
                ? "#FF4444"
                : badge === "New"
                ? "#4CAF50"
                : "#9C27B0",
            color: "white",
            fontWeight: 600,
            fontSize: "0.7rem",
            height: 24,
          }}
        />
      )}

      {/* Product Image */}
      <CardMedia
        component="img"
        image={item.image || `https://picsum.photos/seed/${item.id}/400/600`}
        alt={item.name}
        sx={{
          objectFit: "cover",
          height: 320,
          bgcolor: "#f5f5f5",
        }}
        onError={(e) => {
          e.target.src = `https://picsum.photos/seed/${item.id}/400/600`;
        }}
      />

      {/* Product Info */}
      <CardContent sx={{ flexGrow: 1, p: 2, pb: 2.5 }}>
        {/* Product Name */}
     <Box
         sx={{
           display: "flex",
           justifyContent: "space-between",
           alignItems: "flex-start", // allows title to wrap while heart stays top-aligned
           mb: 1,
         }}
       >
         <Typography
           variant="body2"
           sx={{
             fontWeight: 500,
             color: "text.primary",
             flex: 1,
             mr: 1,
             overflow: "hidden",
             textOverflow: "ellipsis",
             display: "-webkit-box",
             WebkitLineClamp: 2,
             WebkitBoxOrient: "vertical",
             "&:hover": {
               color: "primary.main",
             },
           }}
         >
           {item.name}
         </Typography>
         {/* ✅ Wishlist Toggle — inline, right-aligned */}
         <Box sx={{ flexShrink: 0, mt: '-2px' }}>
           <WishlistToggle product={item} />
         </Box>
       </Box>
     

        {/* Rating */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Rating
            value={item.rating || 4}
            precision={0.1}
            size="small"
            readOnly
            sx={{
              color: "#FFB400",
              fontSize: "1rem",
            }}
          />
          <Typography
            variant="caption"
            sx={{ ml: 0.5, color: "#666", fontSize: "0.75rem" }}
          >
            ({item.reviews || 0})
          </Typography>
        </Box>

        {/* Price */}
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1.5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1a1a1a",
              fontSize: "1.125rem",
            }}
          >
            {item.currency} {item.price}
          </Typography>
          {Math.random() > 0.5 && (
            <Typography
              variant="body2"
              sx={{
                textDecoration: "line-through",
                color: "#999",
                fontSize: "0.875rem",
              }}
            >
              {item.currency} {(parseFloat(item.price) * 1.3).toFixed(2)}
            </Typography>
          )}
        </Box>

        {/* Size Options */}
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
          {["S", "M", "L", "XL"].map((size) => (
            <Box
              key={size}
              sx={{
                width: 26,
                height: 26,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ddd",
                borderRadius: "4px",
                fontSize: "0.7rem",
                color: "#666",
                fontWeight: 500,
                "&:hover": {
                  borderColor: "#999",
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              {size}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );

  if (!query) {
    return (
      <Container maxWidth="xl" sx={{ py: 8 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h5" color="text.secondary">
            No search query provided.
          </Typography>
        </Box>
      </Container>
    );
  }

  if (loading && results.length === 0) {
    return (
      <Container maxWidth="xl" sx={{ py: 8 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 400,
          }}
        >
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, sm: 3 } }}>
   

      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        {/* Title and Filters Row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* Left Side - Title and Badge */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#1a1a1a" }}>
               Search Recommendations
            </Typography>
            {/* <Chip
              label={`Based on "Show me dresses"`}
              size="small"
              sx={{
                bgcolor: "#f0f0f0",
                fontSize: "0.75rem",
                height: 28,
              }}
            /> */}
          </Box>

          {/* Right Side - Filter and Sort */}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              startIcon={<FilterList />}
              variant="outlined"
              size="small"
              sx={{
                borderColor: "#ddd",
                color: "#666",
                textTransform: "none",
                fontWeight: 500,
                "&:hover": {
                  borderColor: "#999",
                  bgcolor: "rgba(0,0,0,0.02)",
                },
              }}
            >
              FILTER
            </Button>
            <Button
              startIcon={<Sort />}
              variant="outlined"
              size="small"
              sx={{
                borderColor: "#ddd",
                color: "#666",
                textTransform: "none",
                fontWeight: 500,
                "&:hover": {
                  borderColor: "#999",
                  bgcolor: "rgba(0,0,0,0.02)",
                },
              }}
            >
              Sort by
            </Button>
          </Box>
        </Box>

        {/* Results Count */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, fontSize: "0.875rem" }}
        >
          Showing {results.length} of {totalSize} results for "{query}"
        </Typography>

        {/* Did you mean? */}
        {correctedQuery && correctedQuery.trim() !== query.trim() && (
          <Alert
            severity="info"
            icon={<InfoOutlined />}
            sx={{
              mb: 2,
              borderRadius: 2,
              "& .MuiAlert-message": {
                display: "flex",
                alignItems: "center",
                width: "100%",
              },
            }}
            action={
              <Button
                size="small"
                endIcon={<ArrowForward />}
                onClick={() =>
                  (window.location.href = `?q=${encodeURIComponent(
                    correctedQuery
                  )}`)
                }
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {correctedQuery}
              </Button>
            }
          >
            Did you mean:
          </Alert>
        )}
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 4, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      {/* Results Grid */}
      {results.length === 0 ? (
        <Typography color="text.secondary" sx={{ py: 8, textAlign: "center" }}>
          No products found.
        </Typography>
      ) : (
        <>
          <Grid container spacing={3}>
            {results.map((item, index) => (
              <Grid item xs={6} sm={4} md={3} lg={2.4} key={item.id}>
                <ProductCard
                  item={item}
                  badge={
                    index % 5 === 0
                      ? "Sale"
                      : index % 7 === 0
                      ? "New"
                      : index % 11 === 0
                      ? "Restocked"
                      : null
                  }
                />
              </Grid>
            ))}
          </Grid>

          {nextPageToken && (
            <Box sx={{ textAlign: "center", mt: 6 }}>
              <Button
                variant="outlined"
                size="large"
                onClick={loadMore}
                sx={{
                  px: 5,
                  py: 1.5,
                  textTransform: "none",
                  borderColor: "#ddd",
                  color: "#666",
                  fontWeight: 600,
                  borderRadius: 2,
                  "&:hover": {
                    borderColor: "#999",
                    bgcolor: "rgba(0,0,0,0.02)",
                  },
                }}
              >
                Load More
              </Button>
            </Box>
          )}
        </>
      )}

      {/* You Might Also Like */}
      {youMightLike.length > 0 && (
        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              mb: 4,
              color: "#1a1a1a",
            }}
          >
            You Might Also Like
          </Typography>
          <Grid container spacing={3}>
            {youMightLike.map((item, index) => (
              <Grid item xs={6} sm={4} md={2.4} key={item.id}>
                <ProductCard
                  item={item}
                  badge={index === 0 ? "Popular" : null}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Container>
  );
}